import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/google': {
    width: 488,
    height: 512,
    paths: [
      {
        d: 'M488 261.8c0 141.5-96.9 242.2-240 242.2-137.2 0-248-110.8-248-248s110.8-248 248-248c66.8 0 123 24.5 166.3 64.9l-67.5 64.9c-88.3-85.2-252.5-21.2-252.5 118.2 0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9h-140.8v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z'
      }
    ]
  }
})
